import {Result} from '@app/models/result.model';
import {TypeOption} from '@app/models';

export const resultA: Result = {
  type: TypeOption.A,
  title: `Le Partenaire Autoritaire`,
  constat: `Ton duo intérieur est en crise. En voulant la protéger des risques, des factures ou du jugement,
  tu as fini par l'enfermer. Ta flamme ne se sent plus libre de respirer ;
  elle s'est murée dans le silence ou cherche désespérément à s'échapper.
  Tu es devenu son gardien de prison alors qu'elle attendait un garde du corps.`,
  key: `Le secret pour qu’elle retrouve son éclat ? Ouvre la cage. Laisse-la faire une petite erreur,
  une petite folie, une petite dépense "inutile". Montre-lui que tu l'aimes plus que ta propre sécurité.`
}

export const resultB: Result = {
  type: TypeOption.B,
  title: `Le Partenaire Distant`,
  constat: `Vous vivez comme des étrangers sous le même toit. Ta flamme est toujours là, mais son regard est vide.
   Elle se sent invisible. C’est le stade de la "colocation polie" : on ne se dispute pas, mais on ne se voit plus.
   Le lien s'étiole par manque d'attention.`,
  key: `Ta flamme ne meurt pas de faim, elle meurt de froid. Elle a besoin de ton regard, pas de ta perfection.
  Le secret ? Le "micro-rendez-vous": un café, une musique, un soupir partagé.
  Dis-lui simplement : « Je sais que tu es là, et je m'excuse d'avoir été ailleurs. »`
}

export const resultC: Result = {
  type: TypeOption.C,
  title: `Le Partenaire Passionné`,
  constat: `Ton duo est radieux. Ta flamme est ta meilleure alliée, elle est prête à te suivre au bout du monde parce
  qu'elle se sent aimée et écoutée. Tu as compris que ta vitalité est une relation vivante
  qui se nourrit chaque jour de petits soins et de présence.`,
  key: `Attention à l'habitude ! Le plus grand danger des couples qui s'aiment est de croire qu'on connaît l'autre par cœur.
  Continue de demander à ta flamme : « Et aujourd'hui, qu'est-ce qui te ferait briller ? »,
  car sa lumière change avec les saisons de ta vie.`
}
